import createClient, { Client } from 'openapi-fetch'

import getRestApiUrl from '@kidzonet/get-rest-api-url'
import { getAuthInfo, refresh, revoke } from '@kidzonet/ts-api-control-auth'
import type { paths } from '@kidzonet/ts-api-generator/clients/control-auth'
import { AuthMiddleware, ErrorHandlingMiddleware, getRefreshToken } from '@kidzonet/ts-api-localstorage-middleware'

declare global {
    // eslint-disable-next-line vars-on-top
    var ControlAuthApiClient: Client<paths>
}

export default () => {
    const baseUrl = getRestApiUrl()

    globalThis.ControlAuthApiClient = createClient<paths>({ baseUrl: `${baseUrl}/v3/public/auth` })
    globalThis.ControlAuthApiClient.use(AuthMiddleware)
    globalThis.ControlAuthApiClient.use(ErrorHandlingMiddleware)

    window.NEW_AUTH_API = {
        getAuthInfo,
        refresh,
        revoke,
    }

    window.getRefreshToken = getRefreshToken
}
